import {
  SELECTED_AUTHOR_AI_INSTANCE_ID,
  SELECTED_SHORTCUT_ID,
  SELECTED_TEMPLATE_DATA,
  PRE_SHORTCUT_SEQUENCE,
  POST_SHORTCUT_SEQUENCE,
  TEMPLATES_SEQUENCE
} from '../../common/actionTypes';
const INITIAL_STATE = {
  selectedAuthorAiInstanceID: '',
  selectedShortcutID: '',
  // templatesSequence: {
  //   oldSequece: [],
  //   newSequence: []
  // },
  // postShortcutSequence: {
  //   oldSequece: [],
  //   newSequence: []
  // },
  // preShortcutSequence: {
  //   oldSequece: [],
  //   newSequence: []
  // }
};

const AuthorAiReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }

  switch (action.type) {
    case SELECTED_AUTHOR_AI_INSTANCE_ID: {
      return {
        ...state,
        selectedAuthorAiInstanceID: action.payload
      };
    }
    case SELECTED_SHORTCUT_ID: {
      return {
        ...state,
        selectedShortcutID: action.payload
      };
    }
    case SELECTED_TEMPLATE_DATA: {
      return {
        ...state,
        selectedTemplateData: action.payload
      };
    }
    case PRE_SHORTCUT_SEQUENCE: {
      return {
        ...state,
        preShortcutSequence: action.payload
      };
    }
    case POST_SHORTCUT_SEQUENCE: {
      return {
        ...state,
        postShortcutSequence: action.payload
      };
    }
    case TEMPLATES_SEQUENCE: {
      return {
        ...state,
        templatesSequence: action.payload
      };
    }
    default:
      return state;
  }
};

export default AuthorAiReducer;